import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WckWeekPlan from '@/types/table/wckWeekPlan';
import { FilesManageData } from '@/api/generated/filesManageController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WckWeekPlanData extends WckWeekPlan {
  leaderIds?: string | undefined;
  filesManage?: FilesManageData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WckWeekPlanController extends BaseController {
  static view(params: ANY_OBJECT) {
    // return super.get<WckWeekPlanData>(API_CONTEXT + '/app/weeklySchedule/viewWeeklySchedule', params, httpOptions);
    return super.get(API_CONTEXT + '/app/weeklySchedule/viewWeeklySchedule', params);
  }

  static deleteTask(params: ANY_OBJECT) {
    return super.get(API_CONTEXT + '/app/weeklySchedule/doDeleteStatus', params);
  }

  static saveTask(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/weeklySchedule/saveWeeklySchedule', params);
  }

  static updateTask(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/weeklySchedule/updateWeeklySchedule', params);
  }

  static viewById(params: ANY_OBJECT) {
    return super.get(API_CONTEXT + '/app/weeklySchedule/viewById', params);
  }

  static viewCopyBusinessData(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/weeklySchedule/viewCopyBusinessData', params);
  }
  static getUserDeptList(params: ANY_OBJECT) {
    // return super.get<WckWeekPlanData>(API_CONTEXT + '/app/weeklySchedule/viewWeeklySchedule', params, httpOptions);
    return super.post(API_CONTEXT + '/app/weeklySchedule/getUserDeptList', params);
  }
  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WckWeekPlanData>>(API_CONTEXT + '/app/weeklyScheduleDetail/getUserInformation', params, httpOptions);
  }

}
